<template>
  <div class="wrapper">
    <div id="scroll">
      <van-pull-refresh v-model="isLoading" @refresh="getData(1)">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length > 0 ? '我已经到底了~' : ''"
          @load="getData"
          style="min-height: calc(100vh - 0.01rem); padding-top: 0.01rem"
          :immediate-check="false"
          :offset="20"
          v-if="list.length > 0 "
        >
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item.refund_nbr)"
          >
            <div class="left" v-if="pageType=='2'">
              <span class="time">消息类型：<span class="title">退款</span></span>
              <span class="time">订单编号：{{item.order_nbr}}</span>
              <span class="time">售后编号：{{item.show_nbr}}</span>
              <span class="time">退款时间：{{item.create_time}}</span>
            </div>
            <div class="right">
              <span class="amount">+{{parseFloat(item.amount)}}</span>
              <img src="./../../assets/images/index/img_back.png" alt />
            </div>
          </div>
        </van-list>
        <div id="empty" v-if="list.length == 0">
          <img src="./../../assets/images/myNotice/noYJnotice.png" alt />
          <div>暂无消息</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {},
  data() {
    return {
      pageType:'',
      list: [],
      loading: false,
      isLoading: false,
      finished: true,
      pageIndex: 0,
      scroll: 0,
      keepAlive: true,
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/myNotice" || from.path == "/index") {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    toDetail(nbr){
      if(this.pageType=='1') return false
      this.linkTo(`replacementdetail?nbr=${nbr}`)
    },
    linkTo(url) {
      this.$router.push({
        path: "/" + url,
        query: { supNbr: this.userInfo.nbr },
      });
    },
    getData(bool) {
      if (bool) this.pageIndex = 0;
      if(this.pageType=='1'){
        this.$commonPost({
          jydm: "flow_70204",
          flow_70204: {
            user_nbr: this.userInfo.nbr,
            page_index: 10 * this.pageIndex,
            num_per_page: 10,
          },
        })
        .then((resp) => {
          if (resp.resp_code == 0 && resp.resp_result == 0) {
            let arr = [];
            if (resp.list) {
              if (resp.list.length > 0) {
                arr = resp.list;
              } else {
                arr.push(resp.list);
              }
            }
            this.list = (bool ? [] : this.list).concat(arr);
            if (arr.length < 10) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            this.isLoading = false;
            this.loading = false;
            this.pageIndex += 1;
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
      }else if(this.pageType=='2'){
        this.$commonPost({
          jydm: "flow_40082",
          flow_40082: {
            user_nbr: this.userInfo.nbr,
            page_index: 10 * this.pageIndex,
            num_per_page: 10,
          },
        })
        .then((resp) => {
          if (resp.resp_code == 0 && resp.resp_result == 0) {
            let arr = [];
            if (resp.list) {
              if (resp.list.length > 0) {
                arr = resp.list;
              } else {
                arr.push(resp.list);
              }
            }
            this.list = (bool ? [] : this.list).concat(arr);
            if (arr.length < 10) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            this.isLoading = false;
            this.loading = false;
            this.pageIndex += 1;
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
      }
    },
  },
  created() {},
  activated() {
    this.pageType= this.$route.query.type
    document.title = this.pageType=='2'?"退款提醒":'';
    if (!this.keepAlive) {
      //将高度滚动到原来离开页面的高度
      document.getElementById("scroll").scrollTop = this.scroll;
      return false;
    } else {
      this.list=[]
      this.getData(1)
    }
    if(this.pageType=='1'){
      this.$commonPost({
        jydm: "flow_70205",
        flow_70205: {
          user_nbr: this.userInfo.nbr,
        },
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (document.getElementById("scroll")) {
      this.scroll = document.getElementById("scroll").scrollTop;
    }
    next();
  },
};
</script>
<style scoped lang='stylus'>
.wrapper >>> .van-pull-refresh__track {
  min-height: calc(100vh);
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;
}
#empty {
  margin: 0 auto 0;
  padding-top: 1.2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 4.5rem;
    height: 2.8rem;
    margin-bottom: 0.1rem;
  }
  div {
    color: #999;
    font-size: 0.28rem;
    font-weight: 500;
    display: inline-block;
  }
}
.item {
  width: 100%;
  padding: 0 0.2rem;
  box-sizing: border-box;
  height: 2.1rem;
  background: #fff;
  margin-bottom: 0.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-size: 0.24rem;
      color: #333333;
      font-weight: 500;
      line-height: 0.4rem;
    }
    .time {
      font-size: 0.24rem;
      color: #bcbcbc;
      line-height: 0.33rem;
      font-weight: 500;
      margin: 0.04rem 0;
    }
  }
  .right {
    display: flex;
    align-items: center;
    .amount {
      font-size: 0.32rem;
      color: #ff9007;
      font-weight: 500;
      margin-right: 0.1rem;
    }
    img {
      width: 0.34rem;
      height: 0.34rem;
    }
  }
}
#scroll {
  height: calc(100vh);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/index/myNoticeYj.vue